import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";

interface SelectOption {
  id: number;
  label: string;
}

export default function Goal_9_Promotion() {
  const [isAnimating, setIsAnimating] = useState(false); // 애니메이션 상태 추가

  const pageKey = "goal_9"; // 페이지를 구분할 키 값

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: "/promotion-onboarding/goal/10",
    });

  const selectOptionList: SelectOption[] = [
    { id: 1, label: "최대한 빠르게" },
    { id: 2, label: "보통의 속도" },
    { id: 3, label: "부담없이 천천히" },
  ];

  // 버튼 선택 로직
  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{
          color: theme.vars.palette.Content.Strong,
        }}
      >
        {"선호하는 프로그램 진행 속도가 있을까요?"}
      </CustomTypography>
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }, optionIndex) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                size={"lg"}
                sx={{
                  transition: "background-color 0.3s ease", // ease 애니메이션 추가
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
